module.exports = __webpack_public_path__ + "img/reunion2022.c4162216.jpg";